import { createStore } from "@xstate/store";

export type BookingFlow = "protocols" | "consult";

export type BookingPage =
  | "mode-select"
  | "protocols.form"
  | "protocols.slots"
  | "consult.form"
  | "consult.slots"
  | "consult.confirm";

const FLOW_FIRST_PAGE: Record<BookingFlow, BookingPage> = {
  protocols: "protocols.form",
  consult: "consult.form",
};

const PAGE_NEXT: Partial<Record<BookingPage, BookingPage>> = {
  "protocols.form": "protocols.slots",
  "consult.form": "consult.slots",
  "consult.slots": "consult.confirm",
};

const PAGE_PREV: Partial<Record<BookingPage, BookingPage>> = {
  "protocols.slots": "protocols.form",
  "consult.slots": "consult.form",
  "consult.confirm": "consult.slots",
};

export function createBookingStore(initialFlow?: BookingFlow) {
  return createStore({
    context: {
      flow: (initialFlow ?? null) as BookingFlow | null,
      page: (initialFlow ? FLOW_FIRST_PAGE[initialFlow] : "mode-select") as BookingPage,
    },
    on: {
      "booking.setMode": (_ctx, e: { flow: BookingFlow }) => ({
        flow: e.flow,
        page: FLOW_FIRST_PAGE[e.flow],
      }),

      "booking.next": (ctx) => {
        const next = PAGE_NEXT[ctx.page];
        if (!next) return ctx;
        return { ...ctx, page: next };
      },

      "booking.back": (ctx) => {
        const prev = PAGE_PREV[ctx.page];
        if (prev) return { ...ctx, page: prev };
        // First page of flow → back to mode-select
        return { flow: null, page: "mode-select" as BookingPage };
      },

      "booking.reset": () => ({
        flow: null as BookingFlow | null,
        page: "mode-select" as BookingPage,
      }),
    },
  });
}

export type BookingStore = ReturnType<typeof createBookingStore>;
